<template>
  <div class="grid-x flex-grow">
    <Loading class="flex-grow" :loading="waitPending">
      <div class="cell auto cell-block-y flex flex-col flex-grow">
        <div class="flex flex-col flex-grow">
          <UserProfile
            :payload="customer"
            :pins="pins"/>
          <div class="flex flex-row items-center justify-between mt-4 py-4 px-8">
          <span class="text-danger text-16px leading-18px font-bold">
            {{ $delve(customer, 'blockingReason') }}
          </span>
            <button
              class="btn btn-sm btn-outline-primary"
              @click="$router.push({
              name: 'customers',
            })">Назад</button>
          </div>
        </div>
      </div>
    </Loading>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import UserProfile from '@/components/User/UserProfile.vue';
import Loading from '@/components/Loading.vue';

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  components: {
    UserProfile,
    Loading,
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters({
      customers: 'customers/customers',
    }),
    waitKey() {
      return `fetch.customer.${this.id}`;
    },
    waitPending() {
      return this.$wait.is(this.waitKey);
    },
    customer() {
      return this.customers(this.id);
    },
    pins() {
      return [
        {
          title: 'Создано объектов',
          data: this.$numeral(this.$delve(this.customer, 'subjectsCount')).format('0,0'),
        },
        {
          title: 'Общая сумма заказов',
          data: this.$numeral(parseFloat(this.$delve(this.customer, 'totalOrderPrice'))).format('0,0 $'),
        },
        {
          title: 'Дата последнего заказа',
          data: this.$options.filters.date(this.$delve(this.customer, 'lastOrderDate')),
        },
        {
          title: 'Сумма последнего заказа',
          data: this.$numeral(parseFloat(this.$delve(this.customer, 'lastOrderPrice'))).format('0,0 $'),
        },
      ];
    },
  },
  filters: {
    date(s) {
      const date = moment(s);
      if (date.isValid()) {
        return date.format('DD.MM.YYYY');
      }
      return null;
    },
  },
};
</script>
